import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";
import type { Video } from "@/types/video";
import { getVideosByCategory } from "@/utils/video";
import VideoCard from "@/components/feature/VideoCard";

export default function FeaturedChannels() {
  const [activeId, setActiveId] = useState(categories[0].id);

  const list = useMemo<Video[]>(() => {
    return [...getVideosByCategory(activeId)]
      .sort((a, b) => b.plays - a.plays)
      .slice(0, 6);
  }, [activeId]);

  const activeCat = categories.find((c) => c.id === activeId);

  return (
    <section className="w-full px-4 md:px-8 py-6 md:py-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-5">
        <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
          精选推荐
        </h2>
        <div className="flex items-center gap-1 overflow-x-auto xg-scroll-hide">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => setActiveId(cat.id)}
              className={`px-3.5 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                activeId === cat.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:text-primary-600"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      {activeCat && (
        <p className="text-sm text-foreground-500 mb-4">{activeCat.desc}</p>
      )}

      {list.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-5">
          {list.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      ) : (
        <div className="py-16 text-center text-foreground-500 text-sm">
          该频道暂无相关视频
        </div>
      )}

      <div className="mt-6 flex justify-center">
        <Link
          to={`/category/${activeId}`}
          className="inline-flex items-center gap-1 px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看「{activeCat?.name}」全部视频
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
    </section>
  );
}